/* eslint-disable import/no-mutable-exports */

import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import generateStoreBundle from 'apps/store'
import ErrorBoundary from 'apps/containers/App/ErrorBoundary'
import LifecycleEvents from 'common/LifecycleEvents/Component'

export let store
export let sagas

class AppContainer extends React.Component {
    constructor() {
        super()

        if (module.hot) {
            module.hot.accept('apps/store', async () => {
                const { default: nextStoreBundle } = await import('apps/store')

                this.updateStore(nextStoreBundle)
            })
        }

        this.state = {
            reduxStore: null,
            errors: [],
        }

        this.storeInit = this.storeInit.bind(this)
        this.updateStore = this.updateStore.bind(this)
    }

    componentDidMount() {
        this.storeInit()
    }

    storeInit(error) {
        const { errors } = this.state;
        ({ store, sagas } = generateStoreBundle())

        sagas.toPromise().catch((e) => {
            this.storeInit(e)
        })

        this.setState({
            reduxStore: store,
            ...(error && {
                errors: [
                    ...errors,
                    error,
                ],
            }),
        })
    }

    updateStore(nextStoreBundle) {
        const { reduxStore } = this.state

        reduxStore.replaceReducer(nextStoreBundle.combinedReducers)
    }

    render() {
        const { children } = this.props
        const { reduxStore, errors } = this.state

        if (!reduxStore) {
            return null
        }

        return (
            <Provider store={reduxStore}>
                <ErrorBoundary sagasErrors={errors}>
                    <LifecycleEvents>
                        {children}
                    </LifecycleEvents>
                </ErrorBoundary>
            </Provider>
        )
    }
}

AppContainer.propTypes = {
    children: PropTypes.node.isRequired,
}

export default AppContainer
